import React from "react";
import { Link } from "react-router-dom";
import SEO from '../components/SEO';
import {
  Search,
  BarChart2,
  FileText,
  ThumbsUp
} from "lucide-react"; // Lucide icons

const green = "#8cc540";

const services = [
  {
    title: "Search Engine Optimisation (SEO)",
    desc: "Boost your website's visibility in search engines using white-hat SEO practices including on-page, off-page, and technical SEO strategies.",
    link: "/digital-marketing/search-engine-optimisation-seo",
    icon: <Search size={40} color={green} />,
  },
  {
    title: "Search Engine Marketing (SEM)",
    desc: "Leverage paid advertising on Google and Bing to drive immediate traffic, generate leads, and increase ROI through PPC campaigns.",
    link: "/digital-marketing/search-engine-marketing-sem",
    icon: <BarChart2 size={40} color={green} />,
  },
  {
    title: "Content Marketing",
    desc: "Establish authority and attract your target audience through valuable content like blog posts, videos, infographics, and newsletters.",
    link: "/digital-marketing/content-marketing",
    icon: <FileText size={40} color={green} />,
  },
  {
    title: "Social Media Marketing (SMM)",
    desc: "Build trust and engage your audience on platforms like Facebook, Instagram, and LinkedIn through targeted content and campaigns.",
    link: "/digital-marketing/social-media-marketing-smm",
    icon: <ThumbsUp size={40} color={green} />,
  },
];
const title = "Digital Marketing Services | AKHSoft";
const description = "Maximize your online presence with AKHSoft's expert digital marketing services, including SEO, social media management, content marketing, and PPC advertising.";
const keywords = "AKHSoft digital marketing, SEO, social media marketing, content marketing, PPC, online advertising, marketing strategy, digital agency";
const path = typeof window !== "undefined" ? window.location.pathname : "";
export default function DigitalMarketing() {
  return (
    <>
   <SEO 
      title={title}
      description={description}
      keywords={keywords}
      path={path}
    />
    <div className="w-full">
      {/* Hero Section */}
      <div className="bg-[#8cc540] py-16 text-white text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Digital Marketing Services</h1>
        <p className="text-lg md:text-xl max-w-2xl mx-auto">
          Drive growth and revenue through tailored SEO, SEM, content creation, and social media strategies. We help you reach the right audience at the right time.
        </p>
      </div>

      {/* Services Grid */}
      <div className="bg-white py-10 px-4 sm:px-8 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="border-t-4 border-[#8cc540] rounded-lg shadow p-6 transition-transform hover:scale-[1.02] bg-white"
            >
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="bg-[#f1f7e9] p-3 rounded-full">{service.icon}</div>
                <h3 className="text-xl font-semibold text-gray-800">{service.title}</h3>
                <p className="text-gray-600">{service.desc}</p>
                <Link
                  to={service.link}
                  className="text-[#8cc540] hover:underline font-medium"
                >
                  Learn More →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-[#0a3c6d] py-12 text-white text-center">
        <h2 className="text-3xl font-bold mb-3">Ready to Grow Your Business?</h2>
        <p className="text-lg mb-6">
          Let's build a marketing strategy that delivers results. Get in touch with our experts today.
        </p>
        <Link
          to="/contact-us"
          className="inline-block px-6 py-3 bg-[#8cc540] text-white font-medium rounded hover:bg-[#79a436] transition"
        >
          Contact Us
        </Link>
      </div>
    </div>
    </>
  );
}
